// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2cLm6","content":"styles_content__3f2Rz","checkbox":"styles_checkbox__Z68q6","checkboxLabel":"styles_checkboxLabel__2kA8W"};